import styled from 'styled-components';

import { ThemeProp } from '../../../theme/Themes';
import Button from '..';

const SecondaryButton = styled(Button).attrs((props) => ({
  ...props,
  flat: true,
}))`
  box-shadow: unset;
  background: ${({ theme }: ThemeProp) => theme.colors.layout.surface.default};
  color: ${({ theme }: ThemeProp) => theme.colors.neutrals.c800};
  border: 1px solid ${({ theme }: ThemeProp) => theme.colors.neutrals.c200};

  .nextui-loading {
    --nextui--loadingColor: ${(props: ThemeProp) => props.theme.colors.neutrals.c200} !important;
  }

  &:hover {
    background: ${(props: ThemeProp) => props.theme.colors.neutrals.c100};
  }

  &:focus {
    background: ${(props: ThemeProp) => props.theme.colors.secondary['30-light-blue']};
  }
`;

export default SecondaryButton;
